var ARROWS_CONTAINER_STYLE_TYPE = {
    NONE: 'NONE',
    SHADOW: 'SHADOW',
    BOX: 'BOX',
};
export default ARROWS_CONTAINER_STYLE_TYPE;
//# sourceMappingURL=arrowsContainerStyleType.js.map